/**
 * @class TableColumn
 *
 * Contains column specific modifiers
 *
 * @property {string} className - classes to be applied to every cell in this column (including header)
 * @property {boolean} sortable - specifies if the column is sortable
 */
export default class TableColumn {
    /**
     *
     * @param {string} [className] classes to be applied to every cell in this column (including header)
     * @param {boolean} sortable - specifies if the column is sortable
     */
    constructor(className = "", sortable = false) {
        this._className = className;
        this._sortable = sortable;
    }

    /**
     * @returns {string}
     */
    get className() {
        return this._className;
    }

    /**
     * @returns {boolean}
     */
    get sortable() {
        return this._sortable;
    }
}
